import { inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private msalService = inject(MsalService);

  readonly loggedUser = this.msalService.instance.getActiveAccount();

  /**
   * Get the logged user (MSAL account)
   */
  getLoggedUser(): AccountInfo | null {
    console.log('Logged user:', this.msalService.instance.getActiveAccount());
    return this.msalService.instance.getActiveAccount();
  }

  /**
   * Returns true if the logged user has an admin role.
   * Checks idTokenClaims.roles or idTokenClaims.role for FLEXSEAT-ADMIN or ADMIN.
   */
  isAdmin(): boolean {
    const user = this.getLoggedUser();

    if (!user) {
      return false;
    }

    const claims = (user as AccountInfo & {
      idTokenClaims?: {
        roles?: string[] | string;
        role?: string[] | string;
      };
    }).idTokenClaims;

    if (!claims) {
      return false;
    }

    const roles = claims.roles || claims.role;

    if (!roles) {
      return false;
    }

    if (Array.isArray(roles)) {
      return roles.some(role => {
        const normalizedRole = String(role).toUpperCase();
        return normalizedRole.includes('FLEXSEAT-ADMIN') || normalizedRole.includes('ADMIN');
      });
    }

    const normalizedRole = String(roles).toUpperCase();
    return normalizedRole.includes('FLEXSEAT-ADMIN') || normalizedRole.includes('ADMIN');
  }

}